import { AccessTable } from "../types/accessControl";
import { User } from "../types/user";

export function userCanWrite(user: User, path: string): boolean {

  if (!user) {
    return false;
  }

  const pathControl = Object.keys(AccessTable).find(key => path.startsWith(key));
  if (!pathControl) {
    return true;
  }

  const accessControlKey = AccessTable[pathControl];
  const userAccess = user.access_table[accessControlKey];
  if (!userAccess) {
    return false;
  }

  return userAccess.includes('w');
}

export function userCanRead(user: User, path: string): boolean {

  if (!user) {
    return false;
  }

  const keys = Object.keys(AccessTable);
  let longestKeyMatch = '';
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (key.length > longestKeyMatch.length && path.startsWith(key)) {
      longestKeyMatch = key;
    }
  }

  if (!longestKeyMatch) {
    return true;
  }

  const accessControlKey = AccessTable[longestKeyMatch];
  const userAccess = user.access_table[accessControlKey];
  if (!userAccess) {
    return false;
  }

  return userAccess.includes('r');
}
